import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import Team from "@/views/Team.vue";
import FAQ from "@/views/FAQ.vue";
import UserMyAccountView from "@/views/user/UserMyAccountView.vue";
import LawyerAssociationWorkflow from "@/views/user/LawyerAssociationWorkflow.vue";
import UserRepresentativesView from "@/views/user/UserRepresentativesView.vue";
import UserEventView from "@/views/UserEventView.vue";
// import UserEventCreate from "@/views/UserEventCreate.vue";
import UserEventEdit from "@/views/UserEventEdit.vue";
import ClientList from "@/views/ClientList.vue";
import MonthlyReport from "@/views/MonthlyReport.vue";
import MainDocuments from "@/views/MainDocuments.vue";
import Contact from "@/views/Contact.vue";
import OfficialAnalysis from "@/views/OfficialAnalysis.vue"
import CreditorPlanAdherence from "@/views/CreditorPlanAdherence.vue"
import LawyerPlanAdherence from "@/views/lawyer/LawyerPlanAdherence.vue";

import ObjectionView from "@/views/ObjectionView.vue";
import ObjectionCreate from "@/views/ObjectionCreate.vue";
import ObjectionEdit from "@/views/ObjectionEdit.vue";

import QuestionsList from "@/views/QuestionsList.vue";

import Help from "@/views/Help.vue";

import DocumentsTemplates from "@/views/DocumentsTemplates.vue";
import DocumentCenterPage from "@/views/DocumentCenterPage.vue";
import FileViewer from "@/views/FileViewer.vue";

import CredoresEventView from "@/views/lawyer/Creditor.vue";
import PrivacyPage from "@/views/PrivacyPage.vue";

import LawyerMyAccountView from "@/views/lawyer/MyAccountView.vue";
import LawyerMyAccountEdit from "@/views/lawyer/MyAccountEdit.vue";

import LawyerUserEdit from "@/views/lawyer/EditCreditor.vue";

import UserSummaryView from "@/views/user/UserSummaryView.vue";
import UserProceedings from "@/views/user/UserProceedings.vue";
import PaymentProofsInformed from "@/views/user/PaymentProofsInformed.vue";

import UserCertificateClaim from "@/views/user/UserCertificateClaim.vue";
import LawyerCertificateClaim from "@/views/lawyer/LawyerCertificateClaim.vue";

//import DocumentSignPage from "@/views/user/DocuSign.vue";
//import DocumentSignedPage from "@/views/user/DocuSigned.vue";

import CreditorHome from '@/components/layout/CreditorHome.vue'
import LawyerHome from '@/components/layout/LawyerHome.vue'

//the route guard
const guard = function (to: any, from: any, next: any) {
  const token = localStorage.getItem("token");

  const publicPath = to.matched.find(
    (path) => path.name === "Public" || path.name === "Home"
  );
  if (!token && to.path !== "/login" && !publicPath) {
    next({
      path: "/home",
    });
  } else {
    next();
  }
};

import modules from "@/plugins/module-settings";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        component: Home,
      },
      {
        path: "/arquivo/:name",
        name: "FileViewer",
        component: FileViewer,
      },
      {
        path: '/credores-procurador',
        name: 'CredoresEvent',
        component: CredoresEventView
      },

      {
        path: "/minha-conta",
        name: "userMyAccountView",
        component: UserMyAccountView,
        beforeEnter: guard,
      },
      {
        path: "/credor/editar/:id",
        name: "lawyerUserEdit",
        component: LawyerUserEdit,
        beforeEnter: guard,
      },
      {
        path: "/minha-conta-editar",
        name: "userMyAccountEdit",
        redirect: "/minha-conta",
        beforeEnter: guard,
      },
      {
        path: "/associacao-procurador",
        name: "lawyerAssociationWorkflow",
        component: LawyerAssociationWorkflow,
        beforeEnter: guard,
      },
      {
        path: "/representantes",
        name: "userRepresentatives",
        component: UserRepresentativesView,
        beforeEnter: guard,
      },
      {
        path: "/conta-procurador",
        name: "lawyerMyAccountView",
        component: LawyerMyAccountView,
      },
      {
        path: "/conta-procurador-editar",
        name: "lawyerMyAccountEdit",
        component: LawyerMyAccountEdit,
      },
      {
        path: "/habilitacoes-divergencias",
        name: "userEventview",
        component: UserEventView,
      },
      {
        path: "/ajuda",
        name: "help",
        component: Help,
      },
      // {
      //   path: "/habilitacoes-divergencias/novo",
      //   name: "UserEventCreate",
      //   component: UserEventCreate,
      // },
      // {
      //   path: "/habilitacoes-divergencias/:id",
      //   name: "UserEventEdit",
      //   component: UserEventEdit,
      // },

      // {
      //   path: "/portal-credor",
      //   name: "CreditorHome",
      //   component: CreditorHome,
      // },
      // {
      //   path: "/portal-procurador",
      //   name: "LawyerHome",
      //   component: LawyerHome,
      // },
      {
        path: "/revisao-credito",
        name: "ObjectionView",
        component: ObjectionView,
      },
      {
        path: "/minhas-impugnacoes",
        meta: { module: "site.proceedings" },
        name: "UserProceedings",
        component: UserProceedings,
        beforeEnter: guard,
      },
      {
        path: "/comprovantes-informados",
        meta: { module: "site.payment_proofs" },
        name: "PaymentProofsInformed",
        component: PaymentProofsInformed,
        beforeEnter: guard,
      },
      {
        path: "/revisao-credito/novo",
        name: "ObjectionCreate",
        component: ObjectionCreate,
      },
      {
        path: "/revisao-credito/:id",
        name: "ObjectionEdit",
        component: ObjectionEdit,
      },
      {
        path: "/analise-oficio",
        meta: { module: "site.official_analysis" },
        name: "OfficialAnalysis",
        component: OfficialAnalysis,
      },
      {
        path: "/adesao-plano",
        meta: { module: "site.plan_adherence" },
        name: "CreditorPlanAdherence",
        component: CreditorPlanAdherence,
      },
      {
        path: "/plano-adesao",
        meta: { module: "site.plan_adherence" },
        name: "LawyerPlanAdherence",
        component: LawyerPlanAdherence,
      },
      {
        path: "/modelos-documentos",
        meta: { module: "site.document_models" },
        name: "documentstemplates",
        component: DocumentsTemplates,
      },
      {
        path: "/central-documentos",
        meta: { module: "site.documents_center" },
        name: "DocumentCenterPage",
        component: DocumentCenterPage,
      },
      // {
      //   path: "/assinatura-documentos",
      //   name: "DocumentSignPage",
      //   component: DocumentSignPage,
      // },
      // {
      //   path: "/assinatura/concluida",
      //   name: "DocumentSignedPage",
      //   component: DocumentSignedPage,
      // },
      {
        path: "/privacidade",
        name: "PrivacyPage",
        component: PrivacyPage,
      },
      {
        path: "/certidao-credito",
        meta: { module: "site.chc.request" },
        name: "UserCertificateClaim",
        component: UserCertificateClaim,
      },
      {
        path: "/certidao-credito-procurador",
        meta: { module: "site.chc.request" },
        name: "LawyerCertificateClaim",
        component: LawyerCertificateClaim,
      },
      {
        path: "/resumo",
        name: "UserSummaryView",
        component: UserSummaryView,
      },
      {
        path: "/lista-123milhas",
        name: "clientlist",
        component: ClientList,
      },
      {
        path: "/sobre-processo",
        name: "about",
        component: About,
      },
      {
        path: "/relatorios-mensais",
        name: "monthlyreport",
        component: MonthlyReport,
      },
      {
        path: "/principais-documentos",
        name: "MainDocuments",
        component: MainDocuments,
      },
      {
        path: "/duvidas",
        name: "QuestionsList",
        component: QuestionsList,
      },
      // {
      //   path: "/faq",
      //   name: "faq",
      //   component: FAQ,
      // },
      {
        path: "/contato",
        name: "contact",
        component: Contact,
      },
      {
        path: "/",
        redirect: "/home",
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

// Módulos fechados e ocultos (Módulos e prazos, no backoffice) não abrem pela URL.
router.beforeEach(async (to: any, from: any, next: any) => {
  const route = [...to.matched].reverse().find((item: any) => item.meta && item.meta.module);
  if (!route) return next();
  await modules.load();
  if (modules.isVisible(route.meta.module)) return next();
  next({ path: "/home" });
});


export default router;
